import Icon from '../../../components/AppIcon';

const QuickActionCard = ({ title, description, icon, iconColor, onClick }) => {
  return (
    <button
      onClick={onClick}
      className="w-full bg-card rounded-xl p-4 md:p-6 border border-border shadow-elevation-1 hover:shadow-elevation-2 hover:border-primary/20 transition-all duration-250 text-left group"
    >
      <div className="flex items-start gap-4">
        <div 
          className="flex items-center justify-center w-12 h-12 md:w-14 md:h-14 rounded-lg flex-shrink-0 group-hover:scale-110 transition-transform duration-250"
          style={{ backgroundColor: `${iconColor}15` }}
        >
          <Icon name={icon} size={24} color={iconColor} />
        </div>
        <div className="flex-1 min-w-0">
          <h4 className="text-sm md:text-base font-semibold text-foreground mb-1 group-hover:text-primary transition-colors duration-250">
            {title}
          </h4>
          <p className="text-xs md:text-sm text-muted-foreground line-clamp-2">
            {description}
          </p>
        </div>
        <Icon 
          name="ChevronRight" 
          size={20} 
          color="var(--color-muted-foreground)" 
          className="flex-shrink-0 group-hover:translate-x-1 transition-transform duration-250"
        />
      </div>
    </button>
  );
};

export default QuickActionCard;